import React, { useEffect, useState, useRef } from "react";
import {
    Grid,
    Button,
    TextField,FormControl,InputLabel
} from "@material-ui/core";
import { useSelector } from "react-redux";
import "./masterupload.scss";
import { uploadMasterFile,getMasterFileUpload } from "../../../../Redux/APIs/api_view";
import { tableOptionsUser } from "../../../../Themes/LightTheme";
import Loader from "../../../../Components/Loader/Loader";
import { BootstrapInput,tableIcons } from "../../../../Utilities/Utility";
import SnackbarCustom from "../../../../Components/Snackbar/Snackbar";
import MaterialTable from "material-table";

export default function AttachmentMaster() {
    const tableRef = useRef();
    const [selectedFile, setSelectedFile] = useState([]);
    const [inputFileValue, setInputFileValue] = useState(Date.now);
    const userDetails = useSelector(
        (state) => state.storeUserDetailsReducer.userData
    );
    //azure ad
    const siteToken = useSelector((state) => state.saveBearerTokenReducer);
    const azureToken = useSelector((state) => state.saveTokenReducer);
    const UID = useSelector((state) => state.saveUserIdReducer);
    const [isLoading, setIsLoading] = useState(false);
    //Snackbar
    const [fileData, setFileData] = useState([]);
    const [open, setOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const [tableData,setTableData] = useState([])
    const handleSnackOpen = (text, type) => {
        setSnackMessage(text);
        setAlertType(type);
        setOpen(true);
    };
     useEffect(() => {
        getTableData();
        }, [])

    const columns = [
        { title: 'Master File Uploaded', field: 'filename' },
        
        { title: 'Location', field: 'locationName' },

    ];
    const handleClose = () => {
        setOpen(false);
    };

    const updateExcelHandler = (e) => {
        const chosenFiles = Array.prototype.slice.call(e.target.files);
        setSelectedFile(chosenFiles);
        console.log("SelectedFile", e.target.files);
    };

    const onSubmit = () => {
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('userId', userDetails.userId);
        for (let i = 0; i < selectedFile.length; i++) {
            formData.append("Document", selectedFile[i]);

        }

        if (selectedFile.length > 0) {
            setIsLoading(true);
            uploadMasterFile(siteToken.token,
                azureToken.token,
                UID.id,
                userDetails.userEmail,
                userDetails.gid,
                userDetails.role,
                userDetails.roleId, formData)
                .then((response) => {
                    setIsLoading(false);
                    setSelectedFile("");
                    setFileData(response.data);

                    setIsLoading(false);
                    handleSnackOpen("File Uploaded Successfully.", "success");

                    console.log("Uploaded File Details", response.data);
                })
                .catch(function (error) {
                    setIsLoading(false);
                    handleSnackOpen("Error in saving.", "error");
                    console.log(error);
                });
            setIsFileUploaded(true);
        }
        else {
            setIsLoading(false);
            handleSnackOpen("Select files to Upload", "warning");
        }
    };

     function getTableData() {
            setIsLoader(true);
            getMasterFileUpload(siteToken.token,
                azureToken.token,
                UID.id,
                userDetails.userEmail,
                userDetails.gid,
                userDetails.role,
                userDetails.roleId)
                .then((response) => {
                    setTableData(response);
                    setIsLoader(false);
                })
                .catch((error) => {
                    handleSnackOpen("Error : " + error, "error");
                    setIsLoader(false);
                });
        }

    return (
      <>
          
            <Grid item xs={12} className="left-div">
                <h3 className="heading">Attachment Master</h3>
            </Grid>
            <Grid container spacing={2} className="gridMargin" style={{ marginTop:'10px' }}>
          <Grid item xs={12} sm={4} md={3}>
            <form className="file-upload-form">
              <TextField
                type="file"
                inputProps={{
                  multiple: true,
                }}
                label=""
                variant="filled"
                className="file-upload"
                name="fileUpload"
                onChange={updateExcelHandler}
                key={inputFileValue}
              />
            </form>

            <div style={{ color: "red", fontSize: "0.9rem", marginTop: "8px" }}>
              <strong>Note:</strong> File name should be the same while
              uploading, as they are master templates.
              <br />
              File names should be kept same:
              <ul style={{ marginTop: "4px", marginBottom: 0 }}>
                <li>EM_EA_GF_QM_FR_056 ISIR.xlsm</li>
                <li>EM_EA_GF_QM_FR_033 TFC.xls</li>
                <li>DFM_Format.pptx</li>
                <li>EM_EA_GF_QM_FR_046 TRM.xlsx</li>
                <li>EM_EA_GF_QM_FR_068 PPAP.xlsx</li>
                <li>SQM Check_APQP Questionnaire.pdf</li>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <Button
              className="pt-button--secondary bulk-upload-submit-btn"
              type="button"
              disabled={selectedFile ? false : true}
              onClick={onSubmit}
            >
              Upload
            </Button>
            {/*<span className="mandatoryText">Note: Upload files with fixed names and filetypes.Eg: DFM.pdf</span>*/}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Location
              </InputLabel>
              <BootstrapInput
                type="text"
                id="bootstrap-input"
                name="location"
                disabled
                value={userDetails?.locationName || ""}
              />
            </FormControl>
          </Grid>

           <Grid container spacing={1}>
                              <Grid item xs={12} md={12}>
                                  <MaterialTable
                                      title="Upload Master Table"
                                      tableRef={tableRef}
                                      columns={columns}
                                      data={tableData}
                                      isLoading={isLoader}
                                      icons={tableIcons}
                                      options={tableOptionsUser}
                                     
                                  />
                                  {/* <>
                                      <SnackbarCustom
                                          open={open}
                                          message={snackMessage}
                                          alertType={alertType}
                                          handleClose={handleClose}
                                      />
                                  </> */}
                              </Grid>
                          </Grid>
        </Grid>
        {/* <Grid className="marginChange">
                <span className="mandatoryText">Note: Filenames should match exactly as below<br />1. DFM_Format.pptx<br />2. EM_EA_GF_QM_FR_033 TFC.xls<br />3. EM_EA_GF_QM_FR_046 TRM.xlsx<br />4. EM_EA_GF_QM_FR_056 ISIR.xlsm<br />5. EM_EA_GF_QM_FR_068 PPAP.xlsx</span>
            </Grid>*/}
        <SnackbarCustom
          open={open}
          message={snackMessage}
          alertType={alertType}
          handleClose={handleClose}
        />
        {isLoading ? <Loader loaderText="Loading...!" /> : <></>}
      </>
    );
}